import { SubsidiesHero } from '../components/sections/SubsidiesHero';
import { SubsidiesGrid } from '../components/sections/SubsidiesGrid';
import { SubsidiesCTA } from '../components/sections/SubsidiesCTA';

const SubsidiesIndex = () => (
  <div>
    <SubsidiesHero />
    <SubsidiesGrid />
    <SubsidiesCTA />
  </div>
);

export default SubsidiesIndex;
